import { useRef, useState } from "react";
import { Table } from "./Table";
import { Toast } from "primereact/toast";

export const RevenueReportUserWise = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}